import { useEffect, useLayoutEffect, useState } from 'react';

const MARGIN = 8;
const GAP = 4;

function useFloatingPosition({
  open,
  anchorRef,
  floatRef,
  matchWidth = false,
  align = 'right',
  onDismiss
}) {
  const [style, setStyle] = useState({ position: 'fixed', top: 0, left: 0, right: 'auto' });

  useLayoutEffect(() => {
    if (!open || !anchorRef.current || !floatRef.current) return;
    const anchor = anchorRef.current.getBoundingClientRect();
    const float = floatRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - anchor.bottom - MARGIN - GAP;
    const spaceAbove = anchor.top - MARGIN - GAP;
    const above = float.height > spaceBelow && spaceAbove > spaceBelow;
    const width = matchWidth ? anchor.width : float.width;
    const top = above
      ? Math.max(MARGIN, anchor.top - Math.min(float.height, spaceAbove) - GAP)
      : anchor.bottom + GAP;
    let left;
    if (matchWidth) {
      left = anchor.left;
    } else if (align === 'center') {
      left = anchor.left + (anchor.width - float.width) / 2;
    } else {
      left = anchor.right - float.width;
    }
    left = Math.max(MARGIN, Math.min(left, window.innerWidth - width - MARGIN));
    setStyle({
      position: 'fixed',
      top,
      left,
      right: 'auto',
      width: matchWidth ? anchor.width : undefined,
      maxHeight: Math.max(120, above ? spaceAbove : spaceBelow),
      overflowY: 'auto',
      zIndex: 80
    });
  }, [open, anchorRef, floatRef, matchWidth, align]);

  useEffect(() => {
    if (!open) return undefined;
    const dismiss = (event) => {
      if (event.type === 'scroll' && floatRef.current?.contains(event.target)) return;
      onDismiss();
    };
    window.addEventListener('resize', dismiss);
    window.addEventListener('scroll', dismiss, true);
    return () => {
      window.removeEventListener('resize', dismiss);
      window.removeEventListener('scroll', dismiss, true);
    };
  }, [open, floatRef, onDismiss]);

  return style;
}

export default useFloatingPosition;